const doc = [({"da":({"js":({"admin":({"competition_surveys":({"surveys":({"the_survey_was_removed_from_the_competition":"Spørgeskemaet blev fjernet fra konkurrencen"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;